export default [
  {
    path: '/perfil',
    name: 'perfil',
    component: () => import('@/app-modulo/comuns/perfil/Perfil.vue'),
    meta: {
      resource: 'perfil',
      action: 'auditar',
      pageTitle: 'Meu perfil',
      breadcrumb: [],
    },
  },
]
